
  <ng-container >
    <div class="card-deck">
    <div class="card" >
          <div class="card-body">
            <img (click)="move()" class="card-img-top" src={{data.images[0]}} alt=""  />
          </div>
          <div class="card-footer text-center">
            <div style="margin-top: -20px">
              <p class="float-left" style="font-weight: bold;">{{data.name}}</p>
              <span class="float-right">
                <i (click)="toggleSave()" class="bx {{saved? 'bxs-bookmark' : 'bx-bookmark'}} text-right">  
                </i>
              </span>
            </div>
          </div>
          <div
            class="card-footer"
            style="
              margin-top: -35px;
              background-color: rgba(255, 255, 255, 0);
            "
          >
            <small class="text-muted float-left">{{data.price | currency:'INR'}}</small>
          </div>
      </div>
    </div>
  </ng-container>
        
